export const CONCILIATION_TABS = {
  CONCILIATIONS: 0,
  REPORTS: 1,
  ACCOUNT_STATEMENT_HISTORY: 2,
  CFDI_HISTORY: 3,
  OCR_PROCESS: 4,
} as const
